
let  appEnv = 1 // 0 测试 1 线上
var commonIps, baseUrl, lyqUrl

if(window.location.href.indexOf('https')>-1) {
  window.location.href.indexOf('api.linyouquan.net')>-1?appEnv = 1:appEnv = 0
}else{
  window.location.href.indexOf('api.linyouquan.net')>-1?appEnv = 1 : appEnv = 0
}
if(appEnv){
	//正式
	commonIps = 'https://lyy.linyouquan.net'
	baseUrl = 'https://city.linyouquan.net'
	lyqUrl = 'https://api.linyouquan.net'
}else{
	//测试
	commonIps = 'https://h.linyouquan.net'
	baseUrl = 'https://hh.linyouquan.net'
	lyqUrl = 'https://dev.linyouquan.net'
}

export function baseUrls(){
	return {
		'api':commonIps,
		'url':baseUrl,
		'lyqUrl':lyqUrl
	}
}



// WEBPACK FOOTER //
// ./src/util.js